const getDate = date => {
  // Bug real (auditoría 2026-08-16): un Date inválido (ej. new Date("x"))
  // es un objeto truthy — `date || new Date()` NO caía al fallback, y
  // Intl.DateTimeFormat().format() tiraba, cayendo al catch, donde
  // toLocalYMD devolvía "NaN-NaN-NaN" en vez de una fecha válida. Un valor
  // que ni siquiera es Date-like (string/number suelto) crasheaba DENTRO
  // del catch mismo (date.getFullYear is not a function), sin ningún
  // try/catch que lo cubriera — un TypeError no capturado. Se normaliza a
  // un Date válido ANTES de intentar formatear, con fallback a "hoy".
  let d = date instanceof Date ? date : new Date(date || Date.now())
  if (isNaN(d.getTime())) d = new Date()

  try {
    return Intl.DateTimeFormat('fr-ca', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(d)
  } catch {
    const pad = n => String(n).padStart(2, '0')

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
  }
}

export default getDate
